<button
  class="x-small white violet share"
  (click)="showManager()"
>
  <i class="fa-regular fa-share"></i> Share
</button>
